import React, {Component} from 'react';

import { connect } from 'react-redux'
import Reports from './components/Reports/Reports'

import {
  fetchSlimAccount, fetchQueuedReports
} from 'broker/redux/account'
import {getAuthEmail} from "broker/util/downloader";


const mapDispatchToProps = dispatch => ({
    dispatch
})

class ReportsContainer extends Component {

    constructor(props) {
      super(props)
    }

    componentWillMount() {
      const { dispatch } = this.props
      dispatch(fetchQueuedReports())
      dispatch(fetchSlimAccount())
    }

    render() {
      return <Reports {...this.props} />
    }
}

export default connect((state) => ({ account: state.account, auth: state.auth, email: getAuthEmail(state), root: state.root}), mapDispatchToProps)(ReportsContainer)
